import React, { Component } from 'react';
import './App.css';
import Logo from './components/UI/Logo/Logo';
import Game from './components/UI/Game/Game'

class App extends Component {

  state = {
    isVisible: false,
    difficulty: null,
    timer: 1000,
    level: null,
    startTime : null,
    shuffledCards: [],
    content: 'FLIP',
  }

  gameHandler = (content) => {
    this.setState({ isVisible: false, content: content })
  }
  startGame = (event, type) => {
    event.stopPropagation();
    let level = null
    let timer = 1000;
    let cardsList = []
    if (type === 'casual') {
      level = 8
      timer *= level * 4
    }
    else if (type === 'medium') {
      level = 18
      timer *= level * 5
    }
    else if (type === 'hard') {
      level = 32
      timer *= level * 6
    }
    for (let index = 0; index < level; index++) {
      cardsList.push(index);
      cardsList.push(index);
    }
    cardsList.sort(() => Math.random() - 0.5);
    this.setState({
      isVisible: !this.state.isVisible,
      difficulty: type,
      level: level,
      timer: timer,
      shuffledCards: cardsList,
      startTime : new Date()
    })
  }
  render() {
    return (
      <div className="App-header">
        {this.state.isVisible ? <Game
          clicked={this.startGame}
          gameHandler={this.gameHandler}
          level={this.state.level}
          timer={this.state.timer}
          startTime={this.state.startTime}
          difficulty = {this.state.difficulty}
          shuffled={this.state.shuffledCards} /> : null}
        <Logo clicked={this.startGame} isVisible={this.state.isVisible} content={this.state.content} />
      </div>
    );
  }

  componentDidMount() {
    if (localStorage.getItem('flipped')) {
      return;
    } else {
      localStorage.setItem('flipped', false)
      localStorage.setItem('flip_lost', 0);
      localStorage.setItem('flip_abandoned', 0);
      localStorage.setItem('flip_casual', '-:-');
      localStorage.setItem('flip_medium', '-:-');
      localStorage.setItem('flip_hard', '-:-');
      localStorage.setItem('flip_matched', 0);
      localStorage.setItem('flip_wrong', 0);
      localStorage.setItem('flip_won', 0);
    }

  }
}

export default App;
